import { render, staticRenderFns } from "./MagicEden.vue?vue&type=template&id=7afb65c9"
import script from "./MagicEden.vue?vue&type=script&lang=js"
export * from "./MagicEden.vue?vue&type=script&lang=js"
import style0 from "./MagicEden.vue?vue&type=style&index=0&id=7afb65c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports